import React from 'react'
import { useMemo } from 'sb-hooks'

import { Accordion, NavListItem } from 'components/_new/controls'

import NavItem from '../NavListItem/NavListItem'


export type NavListViewProps = {
  items: NavListItem[]
  pathname?: string
  search?: string
  level?: number // internal prop - passed in NavListItem to nested NavList
  minSubNavLengthToDisplay?: number
  closeNav: () => void
}

export const NavList: React.FunctionComponent<NavListViewProps> = (props) => {
  const { items, pathname, search, level = 1, minSubNavLengthToDisplay = 1, closeNav } = props

  const content = items.map((item, index) => {
    const key = item.dataTestId || item.id || index

    return (
      <NavItem
        key={key}
        item={item}
        pathname={pathname}
        search={search}
        level={level}
        minSubNavLengthToDisplay={minSubNavLengthToDisplay}
        closeNav={closeNav}
      />
    )
  })

  const node = useMemo(() => {
    const isSubNavExist = items.some(({ subNav }) => subNav && subNav.length >= minSubNavLengthToDisplay)

    return isSubNavExist ? Accordion : 'div'
  }, [ items, minSubNavLengthToDisplay ])

  return React.createElement(node, {}, content)
}


export default React.memo(NavList)
